const getters = {
    getProducts(state){
        return state.productList;
    },
    getProductUnits(state){
        return state.productUnits;
    },
    getProductPriceTypes(state) {
        return state.productPriceTypes;
    },
    getProduct(state) {
        return state.product;
    },
    getProductUnit(state){
        return state.productUnit;
    },
    getBarcode(state) {
        return state.barcode;
    }
}

export default getters;